export const getDefaultCountryCode = () => {
    const lang = document.documentElement.lang;
    if (!lang) {
        console.error('HTML lang attribute not found.');
        return null;
    }
    const langToCountryCodeMap = {
        de: 'de',
        en: 'gb',
        fr: 'fr',
        es: 'es',
        ja: 'jp',
        ch: 'ch',
        it: 'it',
    };
    return langToCountryCodeMap[lang] || null;
};
